import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetUserProductsQuery } from 'store/api/productApi';
import ProfileProductCard, { CardType } from 'components/cards/profile-product-card/ProfileProductCard';
import Pagination from 'components/pagination/Pagination';
import { DEFAULT_PAGE } from 'utils/constants';

const DEFAULT_PAGE_SIZE = 6;

const ProfileCompleteProducts = () => {
  const { t } = useTranslation();

  const [currentPage, setCurrentPage] = useState(DEFAULT_PAGE);

  const { data: completeProducts } = useGetUserProductsQuery({
    page: currentPage,
    pageSize: DEFAULT_PAGE_SIZE,
    onlyInSale: false
  });

  if (completeProducts?.models.length === 0) {
    return <div>{t('profile.products.noCompletedProducts')}</div>;
  }

  return (
    <section className="profile-complete-products">
      <article className="products-wrapper">
        {completeProducts?.models.map(product => (
          <ProfileProductCard
            key={product.id}
            product={product}
            cardType={CardType.Complete}
          />
        ))}
      </article>
      <Pagination
        count={completeProducts?.totalPages ?? 1}
        page={currentPage}
        onChange={setCurrentPage}
      />
    </section>
  );
};

export default ProfileCompleteProducts;
